(ns frontend.actions.named-view
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *create-named-view-> [data on-success! on-error!]
  (-> (conn/sendp! :named-view/create data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *share-named-view-> [data on-success! on-error!]
  (-> (conn/sendp! :named-view/share data)
      (p/then on-success!)
      (p/catch on-error!)))
